import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Menubar } from 'primereact/menubar';
import { Divider } from 'primereact/divider';
import { Image } from 'primereact/image';
import { Carousel } from 'primereact/carousel';
import spib from '../../assets/images/SPIB.png';

import electricidadImg1 from '../../assets/images/E1.jpg'; // Imagen de referencia
import electricidadImg2 from '../../assets/images/E2.jpg';
import electricidadImg3 from '../../assets/images/E3.jpg';
import electricidadImg4 from '../../assets/images/E4.jpg';

import './Electricidad.css';


const Electricidad = () => {
    const navigate = useNavigate();
    const electricidadImages = [
        { src: electricidadImg1, alt: 'Electricidad 1' },
        { src: electricidadImg2, alt: 'Electricidad 2' },
        { src: electricidadImg3, alt: 'Electricidad 3' },
        { src: electricidadImg4, alt: 'Electricidad 4' }
    ];

    const imageTemplate = (item) => {
        return (
            <div className="flex justify-content-center align-items-center">
                <Image src={item.src} alt={item.alt} width="100%" className="image-container" />
            </div>
        );
    };
    const itemRenderer = (item) => (
        <a href="#" className="flex align-items-center p-menuitem-link border-round-none">
            <span className={item.icon} />
            <span className="mx-2">{item.label}</span>
            {item.badge && <Badge className="ml-auto" value={item.badge} />}
        </a>
    );

    const items = [
        { label: 'Inicio', icon: 'pi pi-home', command: () => { navigate('/'); } },
        {
            label: 'Proyectos', icon: 'pi pi-search', items: [
                { label: 'Electricidad', icon: 'pi pi-bolt', template: itemRenderer, command: () => { navigate('/Electricidad'); } },
                { label: 'Ahorro energético', icon: 'pi pi-cloud', template: itemRenderer, command: () => { navigate('/Ahorro'); } },
                { label: 'Energía Renovable', icon: 'pi pi-sun', template: itemRenderer, command: () => { navigate('/Renovable'); } },
                { label: 'Aire Acondicionado', icon: 'pi pi-compass', template: itemRenderer, command: () => { navigate('/Aire'); } },
                { label: 'Equipos Multisplit y VRF', icon: 'pi pi-info-circle', template: itemRenderer, command: () => { navigate('/Equipos'); } },
                { label: 'Arquitectura e Infraestructura', icon: 'pi pi-building', template: itemRenderer, command: () => { navigate('/Arquitectura'); } },
            ]
        },
        { label: 'Contacto', icon: 'pi pi-envelope', template: itemRenderer, command: () => { navigate('/Contacto'); } }
    ];

    const start = (
        <div className="flex align-items-center gap-2">
            <img alt="logo" src={spib} height="40" className="mr-2" />
            <h3 className="m-0">Soluciones Profesionales de Ingeniería</h3>
        </div>
    );

    const end = (
        <div className="flex justify-content-end w-full">
            <Menubar model={items} />
        </div>
    );
    return (
        <div className="card">
            <div className='fixed-menubar-container'>
                <Menubar start={start} end={end} className="fixed-menubar w-full z-5 shadow-3" />
            </div>
            {/* Sección principal con información de la empresa */}
            <div className="content-container2">
                <div className="content-container grid mt-4 p-1">
                    <div className="col-12 md:col-6 flex align-items-stretch">
                        <Card className="w-full flex flex-column justify-content-between" style={{ backgroundColor: '#efefef' }}>
                            <h3 className="text-primary">Electricidad</h3>
                            <Divider />
                            <p className="text-justify">
                                Automatización, calculo e instalación de
                                cableado de fuerza, para motores,
                                Resistencia, calculos de caida de tension,
                                Sistema de puesta a tierra en plantas
                                industrials, elaboración de gabinetes para
                                mediciones, acometidas monofásicas y
                                acometidas trifásica con tramites ante
                                empresa eléctrica o empresa municipal,
                                dictamenes de capacidad para las
                                extensions de líena o aumento de cargas.
                            </p>
                        </Card>
                    </div>
                    <div className="col-12 md:col-6 flex justify-content-center align-items-center">
                        <Carousel
                            value={electricidadImages}
                            itemTemplate={imageTemplate}
                            numVisible={1}
                            numScroll={1}
                            autoplayInterval={3000}
                            circular
                            showIndicators
                            showNavigators
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Electricidad;